import React, { useState } from "react";
import PublicHeader from "../Header/PublicHeader";
import Footer from "../Footer";
import { AlignCenter } from "react-bootstrap-icons";
import callIcon from '../../Assets/img/icons/call.png';
import emailIcon from '../../Assets/img/icons/email.png';
import locationIcon from '../../Assets/img/icons/location.png';
const ContactForm = () => {
  const [showPopup, setShowPopup] = useState(false);
  const stats = [
    { icon: callIcon },
    { icon: emailIcon },
    { icon: locationIcon }
  ];
  // Custom styles
  const styles = {
    gradientBackground: {
      background: "linear-gradient(135deg, #EEF2FF 0%, #ffffff 50%, #F5F3FF 100%)",
    },
    gradientCard: {
      background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)",
    },
    glassCard: {
      background: "#fff",
      backdropFilter: "blur(10px)",
    },
    gradientText: {
      background: "#0d73b9",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    button: {
      background: "linear-gradient(180deg, #0078BF 0%, #244183 100%)",
      color: "white",
      border: "none",
      padding: "15px 15px",
      fontSize: "24px",
      borderRadius: "15px",
      cursor: "pointer",
      transition: "all 0.3s ease",
    },
    buttonHover: {
      background: "#0a5a94",
    },
    popupOverlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background: "rgba(0, 0, 0, 0.7)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    popupContent: {
      background: "#fff",
      width: "90%",
      maxWidth: "1100px",
      height: "90%",
      borderRadius: "10px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "15px",
      right: "15px",
      background: "transparent",
      border: "none",
      fontSize: "20px",
      cursor: "pointer",
      color: "#333",
    },

  };

  return (
    <>
      <PublicHeader />

      <div className="min-vh-100" style={styles.gradientBackground}>
        <div className="container py-4">
          <div className="text-center mb-5">
            <h1 className="display-5 fw-bold mb-3" style={styles.gradientText}>
              Get in Touch
            </h1>
            <p className="text-muted lead">We'd love to hear from you. Let's start a conversation!</p>
          </div>

          <div className="row g-4 justify-content-center">

            {/* Contact Information Section */}
            <div className="col-lg-12">
              <div className="card border-0 shadow-lg" style={styles.gradientCard}>
                <div className="card-body p-4 p-md-5 text-white">
                  <h2 className="h3 mb-6 text-center">Contact Information</h2>
                  <div className="d-flex flex-wrap justify-content-between">
                    {[
                      { icon: locationIcon, title: "Contact Address", content: ["134-B, X-Block, New Roshanpura, Najafgarh, South West Delhi, New Delhi- 110043"] },
                      { icon: emailIcon, title: "Email", content: [<a href="mailto:connect@apcci.in" className="text-white text-decoration-none">connect@apcci.in</a>] },
                      {
                        icon: callIcon, title: "WhatsApp", content: [
                          <a href="https://wa.me/919625751947" className="text-white text-decoration-none">Naren: +91-9625751947</a>
                        ]
                      },
                    ].map((item, index) => (
                      <div className="d-flex mb-4 pb-2 " key={index}>
                        <div className="rounded-circle bg-white bg-opacity-8 p-3 me-3 flex-shrink-0"
                          style={{
                            width: "50px",
                            height: "50px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={item.icon}
                            alt={`${item.title} icon`}
                            style={{ width: "45px", height: "45px", objectFit: "contain" }}
                          />
                        </div>
                        <div style={{ flex: 1, wordBreak: "break-word" }}>
                          <h5 className="fw-bold mb-2">{item.title}</h5>
                          {item.content.map((line, i) => (
                            <p key={i} className="mb-1 opacity-75">{line}</p>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Message Form and Map Location Section */}
            <>
              <style>{`
    .contact-card {
      height: 90S0px;
    }

    .contact-iframe,
    .map-iframe {
      width: 100%;
      height: 100%;
      border: none;
      border-radius: 8px;
    }
    .map-wrapper {
      flex: 1;
      min-height: 760px;
      position: relative;
    }

    .map-iframe {
      position: absolute;
      inset: 0;
    }

    /* Tablet */
    @media (max-width: 991px) {
      .contact-card {
        height: 650px;
      }

      .map-wrapper {
        min-height: 500px;
      }
    }

    /* Mobile */
    @media (max-width: 767px) {
      .contact-card {
        height: 500px;
      }

      .map-wrapper {
        min-height: 350px;
      }

      .contact-iframe {
        padding: 10px !important;
      }
    }
  `}</style>

              <div className="row g-4 align-items-stretch">

                {/* Contact Form */}
                <div className="col-lg-6 d-flex">
                  <div className="card border-0 shadow-lg w-100 contact-card">
                    <iframe
                      src="https://forms.zohopublic.in/apcci/form/GetinTouch/formperma/hsOlhhGIg80BXqW2dAZGMS68GYt6Eb2JoYe5x3rhetE"
                      title="Get in Touch"
                      className="contact-iframe"
                    />
                  </div>
                </div>

                {/* Google Map */}
                <div className="col-lg-6 d-flex">
                  <div
                    className="card border-0 shadow-lg w-100"
                    style={styles.glassCard}
                  >
                    <div className="card-body d-flex flex-column p-4 h-100">
                      <h2
                        className="h3 text-center mb-4"
                        style={styles.gradientText}
                      >
                        Office Location
                      </h2>

                      <div className="map-wrapper">
                        <iframe
                          src="https://maps.google.com/maps?q=28.603116,76.985444&z=15&output=embed"
                          style={{
                            width: "100%",
                            height: "100%",
                            border: 0,
                            borderRadius: "8px",
                          }}
                          loading="lazy"
                          allowFullScreen
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </>
          </div>

          {/* Collaborate with Us Button
          <div className="text-center mt-4 ">
            <button 
              style={styles.button} 
              onClick={() => setShowPopup(true)}
            >
              Collaborate with Us
            </button>
          </div> */}

          {/* Popup
          {showPopup && (
            <div style={styles.popupOverlay}>
              <div style={styles.popupContent}>
                <button style={styles.closeButton} onClick={() => setShowPopup(false)}>✖</button>
                <iframe
                  src="https://pay.apcci.in/widget/form/JI4ardZIxL0MZf6o4hWP"
                  style={{ width: "100%", height: "100%", border: "none", borderRadius: "3px" }}
                  title="COLLABORATION FORM"
                />
              </div>
            </div>
          )} */}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ContactForm;
